module.exports = __webpack_public_path__ + "static/media/city.c038a633.svg";